import { WithMenu } from "@/app/components/form-fields/select/WithMenu";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { dataAttr } from "@chakra-ui/utils";
import { FloatingTree } from "@floating-ui/react";
import { ChevronDownIcon, CloseIcon } from "@saas-ui/core";
import * as React from "react";

interface RootMenuFullProps {
  label: React.ReactNode;
  isInvalid: boolean;
  children: React.ReactNode;
  isDisabled?: boolean;
  onBlur?: () => void;
  onClear?: () => void;
}

export const RootMenuFull = React.forwardRef<HTMLDivElement, RootMenuFullProps>(
  ({ children, label, isDisabled, isInvalid, onBlur, onClear }, ref) => {
    return (
      <FloatingTree>
        <WithMenu
          onBlur={onBlur}
          render={(props, ref) => (
            <RootMenu
              onClear={onClear}
              isInvalid={isInvalid}
              isDisabled={isDisabled}
              ref={ref}
              {...props}
            >
              {label}
            </RootMenu>
          )}
        >
          {children}
        </WithMenu>
      </FloatingTree>
    );
  }
);

export const RootMenu = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div"> & {
    isInvalid: boolean;
    isDisabled?: boolean;
    onClear?: () => void;
  }
>(({ isInvalid, isDisabled, onClear, ...props }, ref) => {
  const styles = useMultiStyleConfig("SuiSelect", {});

  /* @ts-ignore */
  const focusStyles = styles.field?._focusVisible;
  /* @ts-ignore */
  const readOnlyStyles = styles.field?._readOnly;
  /* @ts-ignore */
  const invalid = styles.field?._invalid;

  const height = styles.field?.h || styles.field?.height;

  const buttonStyles: any = {
    fontWeight: "normal",
    textAlign: "left",
    color: "inherit",
    _active: {
      bg: "transparent",
    },
    minH: height,
    _focus: focusStyles,
    _expanded: focusStyles,
    _readOnly: readOnlyStyles,
    _invalid: invalid,
    minW: 0,
    ...styles.field,
    h: "auto",
  };

  return (
    <div className={isDisabled ? "cursor-not-allowed" : ""}>
      <chakra.div
        sx={buttonStyles}
        data-invalid={dataAttr(isInvalid)}
        className={`menu-button-form-field flex items-center justify-between ${
          isDisabled ? "pointer-events-none" : ""
        }`}
        {...props}
        ref={ref}
      >
        <chakra.div
          __css={{
            display: "block",
            pointerEvents: "none",
            flex: "1 1 auto",
            minW: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.children}
        </chakra.div>
        {!!onClear && (
          <div
            className="px-2"
            onClick={(e) => {
              onClear();
              e.preventDefault();
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              onClear();
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <CloseIcon className="" data-cy="close-indicator" />
          </div>
        )}
        <div className="w-px self-stretch py-1">
          <div className=" bg-gray-200 h-full w-full" />
        </div>
        <div className="px-2 -mr-2">
          <ChevronDownIcon />
        </div>
      </chakra.div>
    </div>
  );
});
